import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* 404 Illustration */}
        <div style={styles.illustrationWrapper}>
          <svg width="280" height="200" viewBox="0 0 280 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Background circles */}
            <circle cx="140" cy="100" r="80" fill="#F3F4F6" opacity="0.5"/>
            <circle cx="140" cy="100" r="60" fill="#E5E7EB" opacity="0.5"/>
            
            {/* 404 Text */}
            <text x="140" y="110" fontSize="72" fontWeight="bold" fill="#111827" textAnchor="middle" fontFamily="system-ui, -apple-system, sans-serif">
              404
            </text>
            
            {/* Magnifying glass */}
            <circle cx="200" cy="70" r="25" stroke="#6366F1" strokeWidth="4" fill="none"/>
            <line x1="218" y1="88" x2="235" y2="105" stroke="#6366F1" strokeWidth="4" strokeLinecap="round"/>
            
            {/* Search lines inside magnifying glass */}
            <line x1="190" y1="65" x2="210" y2="65" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
            <line x1="190" y1="72" x2="205" y2="72" stroke="#6366F1" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
            
            {/* Sad face elements */}
            <circle cx="110" cy="95" r="3" fill="#6B7280"/>
            <circle cx="130" cy="95" r="3" fill="#6B7280"/>
            <path d="M 105 115 Q 120 108 135 115" stroke="#6B7280" strokeWidth="2" fill="none" strokeLinecap="round"/>
          </svg>
        </div>

        {/* Text Content */}
        <h1 style={styles.title}>Page Not Found</h1>
        <p style={styles.description}>
          Sorry, we couldn't find the page you're looking for.
        </p>
        <p style={styles.pathname}>
          <span style={styles.pathnameLabel}>Requested path:</span>
          <code style={styles.code}>{pathname}</code>
        </p>

        {/* Action Buttons */}
        <div style={styles.buttonGroup}>
          <button
            onClick={() => navigate(-1)}
            style={styles.secondaryButton}
            onMouseEnter={(e) => {
              e.target.style.background = "#F9FAFB";
              e.target.style.borderColor = "#9CA3AF";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "white";
              e.target.style.borderColor = "#D1D5DB";
            }}
          >
            <span style={styles.buttonIcon}>←</span>
            Go Back
          </button>
          <Link
            to="/"
            style={styles.primaryButton}
            onMouseEnter={(e) => {
              e.target.style.background = "#4F46E5";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#6366F1";
            }}
          >
            <span style={styles.buttonIcon}>🏠</span>
            Back to Home
          </Link>
        </div>

        {/* Additional Help Text */}
      
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  },
  content: {
    maxWidth: "540px",
    width: "100%",
    textAlign: "center",
    background: "white",
    borderRadius: "20px",
    padding: "3rem 2rem",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)"
  },
  illustrationWrapper: {
    marginBottom: "2rem",
    display: "flex",
    justifyContent: "center"
  },
  title: {
    margin: "0 0 0.75rem 0",
    fontSize: "32px",
    fontWeight: "700",
    color: "#111827",
    letterSpacing: "-0.025em"
  },
  description: {
    color: "#6B7280",
    fontSize: "16px",
    margin: "0 0 1rem 0",
    lineHeight: "1.5"
  },
  pathname: {
    margin: "0 0 2rem 0",
    padding: "0.75rem 1rem",
    background: "#F9FAFB",
    borderRadius: "8px",
    fontSize: "14px",
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem"
  },
  pathnameLabel: {
    color: "#6B7280",
    fontSize: "12px",
    fontWeight: "500",
    textTransform: "uppercase",
    letterSpacing: "0.05em"
  },
  code: {
    background: "#E5E7EB",
    padding: "0.25rem 0.5rem",
    borderRadius: "4px",
    fontFamily: "monospace",
    fontSize: "13px",
    color: "#374151",
    display: "inline-block",
    wordBreak: "break-all"
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    marginBottom: "1.5rem",
    flexWrap: "wrap"
  },
  primaryButton: {
    padding: "12px 24px",
    borderRadius: "10px",
    border: "none",
    background: "#6366F1",
    color: "white",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)"
  },
  secondaryButton: {
    padding: "12px 24px",
    borderRadius: "10px",
    border: "1.5px solid #D1D5DB",
    background: "white",
    color: "#374151",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease"
  },
  buttonIcon: {
    fontSize: "16px"
  },
  helpText: {
    margin: 0,
    color: "#9CA3AF",
    fontSize: "14px"
  },
  link: {
    color: "#6366F1",
    textDecoration: "none",
    fontWeight: "500",
    transition: "color 0.2s ease"
  }
};